import { MessagesData } from 'interfaces/messagesData';
import React, { useContext } from 'react';
import Chart from 'react-apexcharts';
import ApexCharts from 'apexcharts';
import ptBr from 'apexcharts/dist/locales/pt-br.json';
import en from 'apexcharts/dist/locales/en.json';
import la from 'apexcharts/dist/locales/es.json';
import { LanguageContext } from 'contexts/LanguageContext';
import { Row } from 'antd';

interface Props {
	messagesData: MessagesData;
}

export function SentAndReceivedLineChart({ messagesData }: Props) {
	const { dictionary } = useContext(LanguageContext);

	const getOptions = (): ApexCharts.ApexOptions => {
		if (!messagesData) {
			return {};
		}
		const xaxis = [];

		for (const year of Object.keys(messagesData)) {
			for (const month of Object.keys(messagesData[year])) {
				const label = formatDateForLabel(month, year);
				xaxis.push(label);
			}
		}

		const locale = dictionary.locale;
		const title = dictionary.chart_sent_and_received_title;

		return {
			title: { text: title },
			chart: {
				id: 'sent-and-received',
				background: '#fff',
				defaultLocale: locale,
				locales: [ptBr, en, la],
				toolbar: {
					offsetY: 30,
				},
			},
			xaxis: {
				categories: xaxis,
				range: 12,
			},
			grid: {
				padding: { bottom: -10 },
			},
			yaxis: {
				labels: {
					formatter: (value: number) => {
						let newValue;
						if (value) {
							newValue = value.toLocaleString();
						}
						return newValue ?? String(value);
					},
					offsetX: -15,
				},
			},
			stroke: {
				width: 2,
			},
		};
	};

	const formatDateForLabel = (month: string, year: string) => {
		let formattedMonth = month;
		if (Number(month) < 10) {
			formattedMonth = '0' + month;
		}

		const formattedYear = year.slice(-2);

		return `${formattedMonth}/${formattedYear}`;
	};

	const getSeries = () => {
		if (!messagesData) {
			return [];
		}

		const sentSeries = [];
		const receivedSeries = [];

		for (const year of Object.keys(messagesData)) {
			for (const month of Object.keys(messagesData[year])) {
				sentSeries.push(messagesData[year][month].sent);
				receivedSeries.push(messagesData[year][month].received);
			}
		}

		const sent = dictionary.chart_messages_sent;
		const received = dictionary.chart_messages_received;

		return [
			{ name: sent, data: sentSeries },
			{ name: received, data: receivedSeries },
		];
	};

	return (
		<Row>
			<div className="chartWrapper">
				<Chart
					options={getOptions()}
					series={getSeries()}
					type="line"
					width={'100%'}
					height={'100%'}
				/>
			</div>
		</Row>
	);
}
